<script>
    import { onMount } from "svelte";

    export let tabs;
    export let activeTab = '';
    export let minWidth = 0;

    onMount(() => {
        if (activeTab !== ''){
            activeTab = tabs[0].slug;
        }
    });

</script>
<div class="tabs w-100 border-bottom box-l sx-1">
    {#each tabs as tab (tab.slug)}
        <div class="pointer tab block py-iii px-1 text-c" style="min-width: {minWidth}" class:active={activeTab === tab.slug}
             on:click={()=> activeTab = tab.slug}>
            {tab.label}
        </div>
    {/each}
</div>
